__turbopack_context__.v({
  "disabled": "Toggler-module__KKwUiG__disabled",
  "input": "Toggler-module__KKwUiG__input",
  "label": "Toggler-module__KKwUiG__label",
  "thumb": "Toggler-module__KKwUiG__thumb",
  "toggler": "Toggler-module__KKwUiG__toggler",
  "track": "Toggler-module__KKwUiG__track",
});
